import React from "react"

const Icon360Icon = ({ style }) => (
  <svg  style={style} fill="currentColor" viewBox="0 0 30 26">
    <path d="M0.83,8C0.83,3.59,7.15,0,15,0h0.1c7.8,0,14.12,3.59,14.12,8a5,5,0,0,1-.86,2.75C25.82,8,20.79,6.19,15,6.19S4.18,8,1.68,10.75A5,5,0,0,1,.83,8ZM29,11.56h0c-1.75,2.52-5.59,4.44-10.3,5.11V13.83L8.14,19.91,18.66,26V22.86C25.17,21.94,30,18.61,30,14.65V8.87h0a5.51,5.51,0,0,1-1,2.68h0Zm-22.58,10C2.53,20,0,17.52,0,14.65V8.87H0a5.51,5.51,0,0,0,1,2.68H1a11.66,11.66,0,0,0,5.36,3.83v6.19H6.42Z" />
  </svg>
)

export default Icon360Icon



// WEBPACK FOOTER //
// ./src/AtomicComponents/Icons/Icon360Icon.jsx